'use client'

import { createContext, useContext, RefObject } from 'react'

interface FullscreenContextValue {
  containerRef: RefObject<HTMLDivElement | null>
  isFullscreen: boolean
}

const FullscreenContext = createContext<FullscreenContextValue | null>(null)

export function FullscreenProvider({
  children,
  containerRef,
  isFullscreen,
}: {
  children: React.ReactNode
  containerRef: RefObject<HTMLDivElement | null>
  isFullscreen: boolean
}) {
  return (
    <FullscreenContext.Provider value={{ containerRef, isFullscreen }}>
      {children}
    </FullscreenContext.Provider>
  )
}

export function useFullscreen() {
  const context = useContext(FullscreenContext)
  return context
}

/**
 * Returns the container element for portals (dialogs, sheets, etc.)
 * When in fullscreen mode, returns the fullscreen container
 * Otherwise returns undefined (which makes portals render to document.body)
 */
export function usePortalContainer(): HTMLElement | null | undefined {
  const context = useContext(FullscreenContext)
  if (context?.isFullscreen && context.containerRef.current) {
    return context.containerRef.current
  }
  return undefined
}
